import { gql } from '@apollo/client';

export const CREATE_PRODUCT = gql`
  mutation createProduct($product: ProductCreateInput!, $productVariants: [ProductVariantCreateInput!]!) {
    createProduct(product: $product, productVariants: $productVariants) {
      success
      message
      product {
        id
      }
    }
  }
`;

export const UPDATE_PRODUCT = gql`
  mutation updateProduct($id: ID!, $product: ProductUpdateInput!) {
    updateProduct(id: $id, product: $product) {
      success
      message
      product {
        id
      }
    }
  }
`;

export const DELETE_MANY_VARIANTS = gql`
  mutation deleteManyVariants($product: ID!) {
    deleteManyVariants(product: $product) {
      success
      message
      productVariant {
        id
      }
    }
  }
`;

export const GET_PRODUCTS = gql`
  query productVariants(
    $params: QueryParams
    $type: String
  ) {
    productVariants(
      params: $params
      type: $type
    ) {
      info {
        count
      }
      results {
        id
        title
        img
        description
        price
        product {
          id
          name
          description
        }        
      }     
    }
  }
`;
